export var vaultUrlBase = "/dv/rest/api";
export var inspectionUrlBase = "/services/inspections";
export var graphApiUrlBase = "https://api.mcelroy.com";
export var inspectionInterval = 1000 * 60 * 60 * 24 * 365;
export var requireInspectorIdentifier = true;
export var versionNumber = "release-1.4.4"; // PRODUCTION_VERSION gets substituted on